<!-- <mat-icon *ngIf="lang === 'nl'"></mat-icon>
<mat-icon *ngIf="lang === 'en'"></mat-icon> -->
<!-- <img src="/assets/flags/nl.svg" alt="Flag"> -->
<img *ngIf="lang == 'nl'" id="flag" src="./public/flags/nl.svg" alt="nl vlag" (click)="switchLanguage('en')"/>
<img *ngIf="lang == 'en'" id="flag" src="./public/flags/en.svg" alt="en flag" (click)="switchLanguage('nl')"/>
